import Navigation from "@/components/Navigation";
import OptimizedImage from "@/components/OptimizedImage";

const Cryolipolysis = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-24 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-serif mb-8">Cryolipolysis</h1>
          
          {/* Treatment Overview Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
            <div>
              <OptimizedImage
                src="/lovable-uploads/f5f0785d-ce9f-48fb-83ef-fd107242c01d.png"
                alt="Cryolipolysis Treatment"
                className="w-full h-[400px] object-cover rounded-lg shadow-lg"
                priority
              />
            </div>
            <div className="space-y-6">
              <p className="text-lg">
                Cryolipolysis is an innovative fat-reduction treatment that targets and eliminates stubborn fat cells through controlled cooling technology. This non-invasive procedure is FDA-cleared and provides lasting results.
              </p>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold mb-2">How It Works</h3>
                  <p>The treatment uses controlled cooling to target and crystallize fat cells, leading to their natural elimination by the body over time. The process is completely non-surgical and requires no downtime.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Treatment Areas</h3>
                  <ul className="list-disc pl-5 space-y-2">
                    <li>Abdomen</li>
                    <li>Flanks (love handles)</li>
                    <li>Inner and outer thighs</li>
                    <li>Upper arms</li>
                    <li>Back fat</li>
                    <li>Under the chin</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Process Section */}
          <div className="mb-16">
            <h2 className="text-3xl font-serif mb-8">Treatment Process</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              <div>
                <OptimizedImage
                  src="/lovable-uploads/5d16210c-1527-4506-98b4-3ad1ef19310b.png"
                  alt="Cryolipolysis Device"
                  className="w-full rounded-lg shadow-lg mb-6"
                />
                <OptimizedImage
                  src="/lovable-uploads/a8ccfed7-f90b-4d94-93a4-c4e1c14b7d8e.png"
                  alt="Cryolipolysis Treatment Process Diagram"
                  className="w-full rounded-lg shadow-lg"
                />
              </div>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold mb-2">The Process</h3>
                  <ol className="space-y-4">
                    <li className="flex gap-4">
                      <span className="font-bold">1.</span>
                      <p>Initial cooling begins, and you'll feel a cold sensation that quickly fades.</p>
                    </li>
                    <li className="flex gap-4">
                      <span className="font-bold">2.</span>
                      <p>The device delivers precise cooling to target fat cells beneath the skin while leaving surrounding tissue unaffected.</p>
                    </li>
                    <li className="flex gap-4">
                      <span className="font-bold">3.</span>
                      <p>Treated fat cells are crystallized and gradually eliminated through your body's natural processes.</p>
                    </li>
                    <li className="flex gap-4">
                      <span className="font-bold">4.</span>
                      <p>Results become visible within 2-3 months as your body naturally processes the treated fat cells.</p>
                    </li>
                  </ol>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Results & Recovery</h3>
                  <ul className="space-y-2">
                    <li>• No downtime required</li>
                    <li>• Return to normal activities immediately</li>
                    <li>• Progressive results over 2-3 months</li>
                    <li>• Up to 25% fat reduction in treated areas</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="text-center py-12">
            <h3 className="text-2xl font-serif mb-6">Ready to Start Your Transformation?</h3>
            <a
              href="https://na02.patientnow.com/a/EVOLVEDYOU"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary text-white px-8 py-3 rounded-full text-lg hover:bg-primary/90 transition-colors"
            >
              Book Your Consultation
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cryolipolysis;